import {
  Component,
  HostBinding,
  HostListener,
  OnInit,
  PLATFORM_ID,
  Inject,
  ElementRef,
} from '@angular/core';

import {
  Router,
  NavigationStart,
  Event as NavigationEvent,
  NavigationEnd,
} from '@angular/router';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.scss'],
  standalone: false,
})
export class NewHeaderComponent implements OnInit {
  title = 'Inforida';
  public isCollapsed = true;
  public currentUrlState: string = '/home';
  isDropdownOpen: boolean = false;
  isAboutOpen: boolean = false;
  openDropdownIndex: number | null = null;
  menuOpen: boolean = false;
  isBrowser: boolean = false;

  constructor(
    public router: Router,
    public gaService: GoogleAnalyticsService,
    private deviceDetectorService: DeviceDetectorService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.currentUrlState = '/home';
    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationStart) {
        console.log('event', event);
        console.log('event.url', event.url);
        // console.log('event.urlAfterRedirects', event.urlAfterRedirects);
        this.currentUrlState = event.url || this.currentUrlState;
      }
      if (event instanceof NavigationEnd) {
        console.log('event', event);
        console.log('event.url', event.url);
        console.log('event.urlAfterRedirects', event.urlAfterRedirects);
        this.currentUrlState = event.urlAfterRedirects || this.currentUrlState;
      }
    });
    if (this.isBrowser) {
      this.isMobile = window.innerWidth <= 965;
    }
  }

  @HostBinding('class.nav-mobile')
  isMobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.isBrowser) {
      this.isMobile = window.innerWidth <= 965;
    }
  }

  // isMobile(): boolean {
  //   return this.deviceDetectorService.isMobile();
  //   // return (
  //   //   window.matchMedia(`(min-width: 200px)`).matches &&
  //   //   window.matchMedia(`(max-width: 800px)`).matches
  //   // );
  // }

  toggleDropdown(index: number) {
    // this.isDropdownOpen = !this.isDropdownOpen;
    if (this.openDropdownIndex === index) {
      this.openDropdownIndex = null;
    } else {
      this.openDropdownIndex = index;
    }
  }

  closeDropdown() {
    // this.isDropdownOpen = false;
    this.openDropdownIndex = null;
  }

  onHover(value: boolean) {
    this.isDropdownOpen = value;
  }

  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown')) {
      // this.isDropdownOpen = false;
      this.openDropdownIndex = null;
    }
  }

  toggleMenu(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
    console.log(this.menuOpen);
  }
}
